import {inject} from '@angular/core';
import {
  HttpInterceptorFn
} from '@angular/common/http';
import {AuthService} from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (
  req,
  next
) => {

  const authService = inject(AuthService);

  const token = authService.getToken();

  let headers = req.headers;

  if (token) {
    headers = headers.set('Authorization', `Bearer ${token}`);
  }

  return next(req.clone({ headers }));
};

